import React from "react";
import { useHistory } from "react-router-dom";
import Search from "components/Search";
import Button from "components/Button";
import Add from "icons/add-circle.svg";

type Props = {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
};

const RowSearch: React.FC<Props> = ({ search, setSearch }): JSX.Element => {
  let history = useHistory();

  return (
    <div className="flex flex-row w-full justify-between mt-10">
      <div className="flex flex-col my-auto w-72">
        <Search
          placeholder={"Search for entities or lawyers"}
          value={search}
          onChange={(e: any) => setSearch(e.target.value)}
        />
      </div>
      <div className="flex flex-col my-auto">
        <Button
          label={"Add Account"}
          iconLeft={Add}
          className="bg-bt-green text-bt-white h-14 w-40 font-sora rounded-full"
          onClick={() => {
            history.push("/entity-management/create");
          }}
        />
      </div>
    </div>
  );
};

export default RowSearch;
